import { render, staticRenderFns } from "./FlatCard.vue?vue&type=template&id=69bbb91c&lang=pug&"
import script from "./FlatCard.vue?vue&type=script&lang=ts&"
export * from "./FlatCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports